import FieldEditor from "components/FieldEditor";
import { FieldError, BusinessChequing } from "types";
import * as fields from "pages/clientPortfolio/businessClient/businessClientAccounts/businessChequingFieldDefinitions";
import { useEffect, useState } from "react";
import { requiredDateField, requiredTextField } from "common/functions";
import AccountEditTemplate from "pages/clientPortfolio/businessClient/businessClientAccounts/components/AccountEditTemplate";
import { openConfirm } from "components/confirmBox";
export type Props = {
  account: BusinessChequing;
  isSaving: boolean;
  onCancel(): void;
  onSave(account: BusinessChequing): void;
};

function BusinessChequingForm({ account, onCancel, onSave, isSaving }: Props) {
  const [state, setState] = useState<BusinessChequing>(account);
  const [errors, setErrors] = useState<FieldError[]>([]);

  useEffect(() => {
    errors.length > 0 && checkErrors();
  }, [state]);

  const commonProps = {
    state: state,
    errors,
    setState: (state: BusinessChequing) => {
      setState(state);
    },
  };

  function checkErrors() {
    if (!account) {
      return;
    }
    const errorsArray: FieldError[] = [
      ...requiredDateField(fields.businessChequingOpenDate, state),
      ...requiredTextField(fields.businessChequingODPLimit, state),
    ];

    if (
      state.closeDate &&
      state.openDate &&
      state.closeDate.toLowerCase() !== "invalid date" &&
      new Date(state.closeDate) < new Date(state.openDate)
    ) {
      let invalidCloseDateErr: FieldError = {
        id: `${fields.businessChequingCloseDate.id}`,
        label: `${fields.businessChequingCloseDate.label}`,
        error: "Close Date should be after the Open Date",
      };
      errorsArray.push(invalidCloseDateErr);
    }

    setErrors(errorsArray);
    return errorsArray;
  }

  function onSaveClick() {
    const err = checkErrors();
    if (err?.length === 0) {
      if (
        state.closeDate &&
        state.closeDate.toLowerCase() !== "invalid date" &&
        state.balance &&
        state.balance !== 0
      ) {
        openConfirm({
          title: "Error",
          description: `Account Balance should be $0.00 to close the account`,
          isAlert: true,
        });
      } else {
        onSave({
          ...state,
          isAccountClosed:
            state.closeDate && state.closeDate.toLowerCase() !== "invalid date"
              ? true
              : false,
        });
      }
    }
  }

  return (
    <AccountEditTemplate
      id={`BUSINESS_CHEQUING_${account.accountId}_form`}
      onSaveClick={onSaveClick}
      onCancelClick={onCancel}
      isSaving={isSaving}
      type="Chequing"
      accountNumber={account.accountNumber || ""}
      balance={account.balance || 0}
      column1Fields={
        <>
          <FieldEditor<BusinessChequing>
            field={fields.businessChequingOpenDate}
            {...commonProps}
          />
          <FieldEditor<BusinessChequing>
            field={fields.businessChequingAccounNumber}
            {...commonProps}
          />
          <FieldEditor<BusinessChequing>
            field={fields.businessChequingBalance}
            {...commonProps}
          />

          <FieldEditor<BusinessChequing>
            field={fields.businessChequingAvailableFunds}
            {...commonProps}
          />
        </>
      }
      column2Fields={
        <>
          <FieldEditor<BusinessChequing>
            field={fields.businessChequingCloseDate}
            {...commonProps}
          />
          <FieldEditor<BusinessChequing>
            field={fields.businessChequingOverdraftProtection}
            {...commonProps}
          />

          {state.overdraftProtection && (
            <FieldEditor<BusinessChequing>
              field={fields.businessChequingOverdraftType}
              {...commonProps}
            />
          )}

          <FieldEditor<BusinessChequing>
            field={fields.businessChequingODPLimit}
            {...commonProps}
          />
        </>
      }
    />
  );
}

export default BusinessChequingForm;
